import React from "react";
import { withTranslation } from "react-i18next";
import {
  LocalStorageService,
  ContractService,
  CompanyService,
  ClientService
} from "../../../services";
import HelpDeskView from "../../views/help-desk/help-desk.view";
import { REPSEIcon, ProviderREPSE } from "../../../assets/logos/icons";
import { getNavigatorTimezone } from "../../../utils";

class HelpDeskAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      token: "",
      cardHelpDesk: [],
      questionnairesByUser: [],
      cardRepse: false,
      cardHelpDesk: [
        {
          title: props.t("helpDesk.repse.title"),
          text: props.t("helpDesk.repse.description"),
          img: REPSEIcon,
          url: "/repse-status-by-company",
          subCards: [
            {
              title: props.t("helpDesk.manageREPSEProviders-repse"),
              text: props.t("helpDesk.manageREPSEProviders-repse-text"),
              img: ProviderREPSE,
              url: "/contractors-catalog/2"
            },
            {
              title: props.t("helpDesk.consultREPSE"),
              text: props.t("helpDesk.consultREPSE-text"),
              img: REPSEIcon,
              url: "/repse-status-by-company"
            }
          ]
        },
        {
          title: props.t("helpDesk.title.assemblies"),
          text: props.t("helpDesk.assemblies.text"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_ASSEMBLIES}`,
          url: "/assemblies"
        },
        {
          title: props.t("helpDesk.manageContractors"),
          text: props.t("helpDesk.manageContractors-text"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_CONTRATANTES}`,
          url: "/contractors-catalog/1",
          subCards: []
        },
        {
          title: props.t("helpDesk.card.title.createDocuments"),
          text: props.t("helpDesk.card.text.createDocuments"),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_GENERAR_CONTRATO}`,
          url: "/digital-contract/home",
        },
        {
          title: props.t('documentsToRequire.titleCard'),
          text: props.t('documentsToRequire.texDocuments'),
          img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_DOCUMENT_REQUIRE}`,
          url: '/documents-to-require',
        },
      ],
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  companyService = new CompanyService(this.url);
  clientService = new ClientService(this.url)
  timezone = getNavigatorTimezone()



  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    let userType = user.userMetaData.userRoles;

    this.getClientPreferences()
    //User Type
    userType.map((type) => {
      //User type collaborator and administrator
      if (type.role.id === 5 || type.role.id === 6) {
        this.setState({
          cardContractsREPSE: true,
        });
      }
      //User type invited
      if (type.role.id === 4) {
        this.setState({
          cardRepse: true,
          cardHelpDesk: [
            {
              title: "Reportar REPSE",
              text: "Revisa, carga y envía a validar tus documentos REPSE.",
              img: REPSEIcon,
              url: `/guest-repse-documents`
            },
          ],
        });
      }
    });

    try {
      this.setState({
        token: this.token,
        loading: false,
      });
    } catch (error) {
      this.props.history.push("/");
      // this.props.setShowError(true);
      this.setState({
        cardHelpDesk: [],
        loading: false,
      });
    }
  }

  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 2000);
      }
    );
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, questionnaires) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            questionnairesByUser: questionnaires,
          });
          // funcion()
        }, 4000);
      }
    );
  };

  toggleCompletedQuestionsRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value,
    });
  };

  getClientPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PROCEDURES_CONTROL)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        if (preferenceValue) {
          let copyCards = [...this.state.cardHelpDesk]
          let freelance = {
            title: this.props.t("helpDesk.freelance.title"),
            text: this.props.t("helpDesk.freelance.description"),
            img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_CLIENTE}`,
            url: "/configuration",
            subCards: [
              {
                title: this.props.t("helpDesk.entities.title"),
                text: this.props.t("helpDesk.entities.description"),
                img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_ENTIDADES}`,
                url: "/entities-administration"
              },
              // {
              //   title: this.props.t("helpDesk.procedure.title"),
              //   text: this.props.t("helpDesk.procedure.description"),
              //   img: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_HELP_DESK_ADMIN_TRAMITES}`,
              //   url: "/procedure-administration"
              // }
            ]
          }
          copyCards.push(freelance)

          this.setState({
            cardHelpDesk: copyCards
          })
        }
      } else {
        this.props.history.push("/");
        this.setState({
          cardHelpDesk: [],
          loading: false,
        });
      }
    } catch (error) {
      this.props.history.push("/");
      this.setState({
        cardHelpDesk: [],
        loading: false,
      });
    }
  }

  render() {
    return (
      <HelpDeskView
        {...this.state}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleCompletedQuestionsRequesting={
          this.toggleCompletedQuestionsRequesting
        }
      />
    );
  }
}

export default withTranslation()(HelpDeskAction);
